// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClickableController from "./clickable_controller"
application.register("clickable", ClickableController)

import CurrencyAmountController from "./currency_amount_controller"
application.register("currency-amount", CurrencyAmountController)

import CurrencyFieldController from "./currency_field_controller"
application.register("currency-field", CurrencyFieldController)

import DatatransController from "./datatrans_controller"
application.register("datatrans", DatatransController)

import DateFieldController from "./date_field_controller"
application.register("date-field", DateFieldController)

import DenominationFieldController from "./denomination_field_controller"
application.register("denomination-field", DenominationFieldController)

import DesyFormSubmitDisableController from "./desy_form_submit_disable_controller"
application.register("desy-form-submit-disable", DesyFormSubmitDisableController)

import DesyModalController from "./desy_modal_controller"
application.register("desy-modal", DesyModalController)

import DesyProgressIndicatorController from "./desy_progress_indicator_controller"
application.register("desy-progress-indicator", DesyProgressIndicatorController)

import FadeController from "./fade_controller"
application.register("fade", FadeController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import IntegerFieldController from "./integer_field_controller"
application.register("integer-field", IntegerFieldController)

import LocationLookupController from "./location_lookup_controller"
application.register("location-lookup", LocationLookupController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import RouteRestrictionController from "./route_restriction_controller"
application.register("route-restriction", RouteRestrictionController)

import UpcaseFieldController from "./upcase_field_controller"
application.register("upcase-field", UpcaseFieldController)

import TicketAmountsController from "./ticket_amounts_controller"
application.register("ticket-amounts", TicketAmountsController)
